// extracted by mini-css-extract-plugin
module.exports = {"container":"Thumbnail_container__9a7w_","image":"Thumbnail_image__ALvS1","square":"Thumbnail_square__tYYqe","circle":"Thumbnail_circle__06bNP"};